// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"9b8570c2","740":"7d2e0836","783":"8469f61e"}[chunkId] + ".css";
};